/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  ButtonContainer,
  SignupButton,
  ScreenContent,
  MainContainer,
  Title,
  CreateText,
  HeaderWrapper,
  TitleWrapper,
  StyledTextDiv,
  BounceDiv,
} from "./SignupPage.style";

import SignUpFormComponent from "./SignUpFormComponent";
import Loader from "../../../components/Loader/Loader";
import Footer from "../../../components/Footer/Footer";
import Header from "../../../components/Header/Header";

import { ReactComponent as Loading } from "../../../assets/icons/loader-white.svg";

import { isValidEmail, isValidPassword } from "../../../utils/utils";
import openToast from "../../../utils/toast";

import { signUp } from "../../../store/slices/auth/asyncThunks";
import { selectCreateAccountPending } from "../../../store/slices/auth/slice";
import { selectedLocale } from "../../../store/slices/common/slice";

const SignupPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [password, setPassword] = useState("");
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [visibility, setVisibility] = useState(false);
  const [visibility2, setVisibility2] = useState(false);
  const dispatch = useDispatch();
  const continueLoading = useSelector(selectCreateAccountPending);

  const locale = useSelector(selectedLocale);
  const ar = locale === "ar";

  const toastId = useRef(null);

  const [checkValidation, setCheckValidation] = useState(false);

  const validateForm = () => {
    let formIsValid = true;

    if (!fullName) {
      openToast(toastId, "sign-up", "error", t("full-name-is-required"));
      formIsValid = false;
      return;
    }

    if (!email) {
      openToast(toastId, "sign-up", "error", t("email-is-required"));
      formIsValid = false;
      return;
    } else if (!isValidEmail(email)) {
      openToast(toastId, "sign-up", "error", t("invalid-email-format"));

      formIsValid = false;
      return;
    }

    if (!password) {
      openToast(toastId, "sign-up", "error", t("password-is-required"));
      formIsValid = false;
      return;
    } else if (!isValidPassword(password)) {
      openToast(toastId, "sign-up", "info", t("password-contain"));
      formIsValid = false;
      return;
    }

    if (!confirmPassword) {
      openToast(toastId, "sign-up", "error", t("confirm-password-is-required"));
      formIsValid = false;
      return;
    } else if (confirmPassword !== password) {
      openToast(toastId, "sign-up", "error", t("password-dont-match"));
      formIsValid = false;
      return;
    }

    return formIsValid;
  };

  const handleSignup = () => {
    setCheckValidation(true);
    if (validateForm()) {
      dispatch(
        signUp({
          email,
          fullName,
          password,
        })
      )
        .unwrap()
        .then((response) => {
          openToast(
            toastId,
            "signup-success",
            "success",
            t("your-account-has-been-created-successfully")
          );
          navigate("/verify-email");
        })
        .catch((error) => {
          openToast(toastId, "sign-up", "error", t(error.message));
        });
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSignup();
    }
  };

  useEffect(() => {
    document.addEventListener("keypress", handleKeyPress);
    // window.scrollTo(0, 0);

    return () => {
      document.removeEventListener("keypress", handleKeyPress);
    };
  }, [handleKeyPress]);

  return (
    <MainContainer>
      <HeaderWrapper>
        <Header />
      </HeaderWrapper>

      <BounceDiv>
        <ScreenContent>
          <TitleWrapper>
            <Title>{t("welcome-to-ygii")}</Title>
            <StyledTextDiv>
              <CreateText>
                {t("already-have-an-account")}
                <Link to="/" className="signup">
                  {t("log-in")}
                </Link>
              </CreateText>

              <CreateText>{t("submit-your-request")}</CreateText>
            </StyledTextDiv>
          </TitleWrapper>

          <SignUpFormComponent
            ar={ar}
            checkValidation={checkValidation}
            fullName={fullName}
            setFullName={setFullName}
            email={email}
            setEmail={setEmail}
            visibility={visibility}
            visibility2={visibility2}
            confirmPassword={confirmPassword}
            password={password}
            setPassword={setPassword}
            setConfirmPassword={setConfirmPassword}
            setVisibility={setVisibility}
            setVisibility2={setVisibility2}
          />

          {!continueLoading ? (
            <ButtonContainer>
              <SignupButton onClick={handleSignup}>{t("submit")}</SignupButton>
            </ButtonContainer>
          ) : (
            <ButtonContainer>
              <SignupButton disabled>
                <Loading height={30} />
              </SignupButton>
            </ButtonContainer>
          )}
        </ScreenContent>
      </BounceDiv>
      {continueLoading && <Loader />}
      <Footer ar={ar} />
    </MainContainer>
  );
};

export default SignupPage;
